import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const webhookChannel = defineChannel({
  id: 'webhook',
  icon: 'webhook',
  name: 'Webhook',
  shortName: 'webhook',
  noun: 'webhook',
  events: ['attempted', 'sent', 'deferred', 'failed', 'clicked', 'converted', 'drafted', 'undeliverable'],
} as const satisfies ChannelDefinition);
